import { render } from "./ChartJs.vue?vue&type=template&id=d9d507b6"
import script from "./ChartJs.vue?vue&type=script&lang=js"
export * from "./ChartJs.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__